<template>
	<transition name="fade">
		<div class="index-body">
		<div class="wrap">
				
			<div ref="showbox" v-for="(item,index) in itemlist.children" :key="index" class="item ">
				<div class="listbox" @click="Navgateto(item.URL)">
				
					<div class="listicon">
						<IconSvg name="iconjinhuodan" ></IconSvg>
					</div>
					<span class="listdesc">{{item.CAPTION}}</span>
				</div>
				
			</div>
			
		</div>
		
			<router-view></router-view>
		
	</div>
		
		
	</transition>
	
</template>

<script>
	export default{
		data(){
			return{
				code:''
			}
		},
		mounted() {
			
		},
		computed:{
			itemlist(){
				
				let code=this.$route.query.code
				
				if(this.$store.state.Erpmenu[code]){
					console.log("this.$store.state.Erpmenu[code]",this.$store.state.Erpmenu[code].children[2])
					let list=this.$store.state.Erpmenu[code]
					return list
				}else{
					return []
				}
				
			}
		},
		methods:{
			Navgateto(url){
				console.log(url)
				this.$router.replace({name:url,query:{code:this.code}})
			}
		}
		
	}
</script>

<style lang="less" scoped>
.index-body{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f2f2f2;
		.wrap{
			width: 85%;
			margin: 30px;
			//background: red;
			//padding: 15px;
			display: flex;
			flex-wrap: wrap;
			//align-content: flex-start;
			//justify-content: space-around;
			//justify-content: center;
			//align-items: center;
			
			.item{
				
				width: 160px;
				height: 160px;
				background: gold;
				margin: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 3px;
				.listbox{
					//padding: 10px;
					width: 100%;
					height:100%;
					display: flex;
					flex-direction: column;
					//justify-content: center;
					align-items: center;
					background: #c0eb83;
					position: relative;
					//border: 1px solid #ccc;
					border-radius: 3px;
					box-shadow: 3px 3px 10px #808080;
					cursor: pointer;
					&:hover{
						border: 2px solid #fda424;
					}
					
				}
				
				.listicon{
				
					margin-top: 20px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 80px;
					color: #00ccff;
				}
				.listdesc{
					width: 100%;
					height: 35px;
					background: #fff;
					padding: 10px 0;
					position: absolute;
					display: flex;
					align-items: center;
					justify-content: center;
					bottom: 0;
					border-radius: 3px;
				}
			}
		}
	}

</style>
